// Generated from products/analytics/shared/custom/aliveByMistake/actions.ts; run analytics generate:site-runtime.
import { z } from "zod";
import {
  AliveByMistakeChoiceContextSchema,
  AliveByMistakeContextSchema,
  AliveByMistakeCountSchema,
  AliveByMistakeKeySchema,
} from "./context.gen";

const runAction = { context: AliveByMistakeContextSchema };
const choiceAction = { context: AliveByMistakeChoiceContextSchema };
const AliveByMistakeLaunchModeSchema = z.enum(["new", "resume", "retry"]);

export const AliveByMistakeActionPayloadSchema = z.discriminatedUnion("name", [
  z.strictObject({
    ...runAction,
    name: z.literal("launch_requested"),
    mode: AliveByMistakeLaunchModeSchema,
  }),
  z.strictObject({
    ...runAction,
    name: z.literal("launch_finished"),
    mode: AliveByMistakeLaunchModeSchema,
    outcome: z.enum(["started", "failed", "cancelled"]),
    loadMs: AliveByMistakeCountSchema,
  }),
  z.strictObject({ ...runAction, name: z.literal("wave_started") }),
  z.strictObject({
    ...runAction,
    name: z.literal("wave_finished"),
    outcome: z.enum(["cleared", "defeated", "abandoned"]),
    activeMs: AliveByMistakeCountSchema,
    objectiveHealth: z.number().nonnegative(),
    defeatReason: AliveByMistakeKeySchema.nullable(),
  }),
  z.strictObject({
    ...runAction,
    name: z.literal("run_ended"),
    reason: z.enum(["menu", "restart", "defeated"]),
  }),
  z.strictObject({
    ...choiceAction,
    name: z.literal("purchase_result"),
    itemId: AliveByMistakeKeySchema,
    category: z.enum(["weapon", "upgrade", "consumable", "repair", "perk"]),
    ok: z.boolean(),
    currency: z.enum(["gold", "cash"]),
    amount: AliveByMistakeCountSchema,
    reason: z.enum(["purchased", "unaffordable", "unavailable", "failed"]),
  }),
  z.strictObject({
    ...choiceAction,
    name: z.literal("perk_selected"),
    perkId: AliveByMistakeKeySchema,
  }),
  z.strictObject({
    ...runAction,
    name: z.literal("equipment_deployed"),
    itemId: AliveByMistakeKeySchema,
  }),
  z.strictObject({
    ...choiceAction,
    name: z.literal("settings_changed"),
    setting: z.enum(["difficulty", "graphics", "controls"]),
    value: AliveByMistakeKeySchema,
  }),
]);
export type AliveByMistakeActionPayload = z.infer<typeof AliveByMistakeActionPayloadSchema>;
